function capitalize(value: string) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

function amount(value: string | number) {
    return Number(value).toLocaleString('es-ES');
}

function currency(value: number) {
    return Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
    }).format(value);
}

function lowercase(value: string) {
    return value.toLowerCase();
}

function uppercase(value: string) {
    return value.toUpperCase();
}

export default {
    amount,
    capitalize,
    currency,
    lowercase,
    uppercase,
}